import EmblaCarousel from 'embla-carousel';

function initSuccessStories(root: HTMLElement): void {
  const inner = root.querySelector<HTMLElement>('.success-stories__inner');
  if (!inner) return;

  const prevBtn = root.querySelector<HTMLButtonElement>('[data-carousel-prev]');
  const nextBtn = root.querySelector<HTMLButtonElement>('[data-carousel-next]');
  prevBtn?.setAttribute('aria-label', 'Previous success story');
  nextBtn?.setAttribute('aria-label', 'Next success story');

  const slides = Array.from(inner.children).filter((el) =>
    el.classList.contains('success-story-card'),
  ) as HTMLElement[];

  if (!slides.length) {
    if (prevBtn) prevBtn.style.display = 'none';
    if (nextBtn) nextBtn.style.display = 'none';
    return;
  }

  // Build the carousel scaffold in place of the first slide, leaving header
  // blocks above it untouched.
  const carousel = document.createElement('div');
  carousel.className = 'success-stories__carousel';
  const viewport = document.createElement('div');
  viewport.className = 'success-stories__viewport';
  const container = document.createElement('div');
  container.className = 'success-stories__container';
  viewport.appendChild(container);
  carousel.appendChild(viewport);

  inner.insertBefore(carousel, slides[0]);
  slides.forEach((slide) => container.appendChild(slide));
  if (prevBtn) carousel.appendChild(prevBtn);
  if (nextBtn) carousel.appendChild(nextBtn);

  if (slides.length <= 1) {
    if (prevBtn) prevBtn.style.display = 'none';
    if (nextBtn) nextBtn.style.display = 'none';
    slides[0]?.classList.add('is-active');
    return;
  }

  const isHp2 = root.dataset.ssVariant === 'homepage-phase-2';
  const emblaApi = EmblaCarousel(viewport, {
    loop: isHp2 ? false : slides.length > 2,
    align: isHp2 ? 'start' : 'center',
    // Phase 2 mobile: centred looping carousel with side peeks, per Figma.
    ...(isHp2
      ? {
          breakpoints: {
            '(max-width: 768px)': { align: 'center', loop: slides.length > 2 },
          },
        }
      : {}),
  });

  const setActive = () => {
    const selected = emblaApi.selectedScrollSnap();
    slides.forEach((slide, index) => slide.classList.toggle('is-active', index === selected));
    if (isHp2) {
      prevBtn?.toggleAttribute('disabled', !emblaApi.canScrollPrev());
      nextBtn?.toggleAttribute('disabled', !emblaApi.canScrollNext());
    }
  };

  emblaApi.on('select', setActive);
  emblaApi.on('reInit', setActive);
  setActive();

  prevBtn?.addEventListener('click', () => emblaApi.scrollPrev(), false);
  nextBtn?.addEventListener('click', () => emblaApi.scrollNext(), false);
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll<HTMLElement>('[data-success-stories]').forEach(initSuccessStories);
});
